export default "__VITE_ASSET__7cf0ee0f__"